import { ApiClient } from "@/api-client/src/core/api-client";
import {
  AlsoBoughtApiResponse,
  ProductDetailResponse,
  ProductResponse,
  ProductSearchResponse,
  SearchApiResponse,
} from "@/packages/types/products";

const apiClient = new ApiClient();
const webService = apiClient.web;

/**
 * Fetch list of categories
 * @param page default is 1
 * @param limit default is 10
 */
export const fetchGridProducts = async (
  category: number[] | undefined,
  page: number,
  limit: number,
  minPrice?: number,
  maxPrice?: number,
  sort?: string,
  excludeId?: string,
  brandId?: number | undefined
): Promise<ProductSearchResponse> => {
  const params = new URLSearchParams();
  if (category) {
    params.append("categoryId", category.join(","));
  }

  // if (category && category.length > 0) {
  //   category.forEach((id) => {
  //     params.append("categoryId", id.toString());
  //   });
  // }

  params.append("page", page.toString());
  params.append("limit", limit.toString());

  if (minPrice !== undefined) {
    params.append("minPrice", minPrice.toString());
  }
  if (maxPrice !== undefined) {
    params.append("maxPrice", maxPrice.toString());
  }
  if (sort) {
    params.append("sort", sort);
  }
  if (excludeId) {
    params.append("excludeProduct", excludeId);
  }

  if (brandId) {
    params.append("brandId", brandId.toString());
  }
  const response = await webService.get<ProductSearchResponse>(
    `/products?${params.toString()}`
  );

  return response;
};

/**
 * Submit a product review
 * @param productId
 * @param payload - { rating, review, orderId, ... }
 */
export const postProductReview = async (
  productId: number | string,
  payload: Record<string, unknown>
): Promise<import("axios").AxiosResponse<Record<string, unknown>>> => {
  // Use underlying axios instance to return full AxiosResponse so callers can inspect status
  const axiosInstance = webService.getInstance();
  const response = await axiosInstance.post(
    `/products/${productId}/reviews`,
    payload
  );
  return response;
};

export const fetchProductDetailBySlug = async (
  slug: string
): Promise<ProductDetailResponse> => {
  const response = await webService.get<ProductDetailResponse>(
    `/products/${slug}`
  );
  return response;
};
export const fetchAlsoBought = async (
  productId?: number | string
): Promise<AlsoBoughtApiResponse> => {
  const response = await webService.get<AlsoBoughtApiResponse>(
    `/products/${productId}/also-bought-with`
  );

  return response;
};
export const fetchTopSelling = async (): Promise<ProductResponse> => {
  const response = await webService.get<ProductResponse>(
    `/products/top-selling`
  );

  return response;
};
export const fetchSearchSuggestion = async (
  search: string
): Promise<SearchApiResponse> => {
  const response = await webService.get<SearchApiResponse>(
    `products/search-suggestion?keyword=${search}`
  );

  return response;
};
export const fetchSearchResult = async (
  page: number,
  limit: number,
  search: string,
  sort?: string
): Promise<ProductSearchResponse> => {
  const params = new URLSearchParams();
  params.append("keyword", search); // no need to encode
  params.append("page", page.toString());
  params.append("limit", limit.toString());

  if (sort) {
    params.append("sort", sort);
  }

  const response = await webService.get<ProductSearchResponse>(
    `/products/search?${params.toString()}`
  );

  return response;
};
export const fetchAllProducts = async (
  page: number,
  limit: number,
  search: string,
  sort?: string
): Promise<ProductSearchResponse> => {
  const params = new URLSearchParams();
  params.append("keyword", search); // no need to encode
  params.append("page", page.toString());
  params.append("limit", limit.toString());

  if (sort) {
    params.append("sort", sort);
  }

  const response = await webService.get<ProductSearchResponse>(
    `/products?${params.toString()}`
  );

  return response;
};
export const fetchAllProductsWithDeals = async (
  page: number,
  limit: number,
  search: string,
  sort?: string
): Promise<ProductSearchResponse> => {
  const params = new URLSearchParams();
  params.append("keyword", search); // no need to encode
  params.append("page", page.toString());
  params.append("limit", limit.toString());

  if (sort) {
    params.append("sort", sort);
  }

  const response = await webService.get<ProductSearchResponse>(
    `/products/crazy-deals?${params.toString()}`
  );

  return response;
};
